import styles from "./style.module.css";
export default function TableActionsContainer({ children }) {
  return (
    <div className={`${styles["table-actions-cont"]} px-3 py-2`}>
      {children}
    </div>
  );
}
